import React from 'react';
import classes from './Transact.module.css';
import plus from '../../../../Assets/pluss.png';
import { NavLink, Link, useLocation, useNavigate } from "react-router-dom";








export default function Transact() {
const navigate = useNavigate();
    return (
        <div className={classes.graphContainer}>

            {/* table 1 begins here */}

            <div className={classes.graphContainKnt}>
                {/* Header */}
                <div className={classes.flex}>
                    <div>
                        <h2 className={classes.rvntxt}>Recent Transactions</h2>
                        <p className={classes.rvntxtsml}>Latest financial activity</p>
                    </div>
                    <div>
                        <p className={classes.viwal}>View All</p>
                    </div>
                </div>

                {/* Transaction  */}
                <div className={classes.trstnal}>
                    <div className={classes.dotter} >
                        <div className={classes.dot} />
                        <div className={classes.dotters} >
                            <div>
                                <p className={classes.akant}>GTB Business Account</p>
                                <p className={classes.akantnum}>****6789</p>
                            </div>
                            <div>
                                <p className={classes.amount}>₦0.00</p>
                            </div>

                        </div>
                    </div>
                    <div className={`${classes.dotter} ${classes.topspc}`}>
                        <div className={classes.dot} />
                        <div className={classes.dotters} >
                            <div>
                                <p className={classes.akant}>Access Bank Current</p>
                                <p className={classes.akantnum}>****4321</p>
                            </div>
                            <div>
                                <p className={classes.amount}>₦0.00</p>
                            </div>

                        </div>
                    </div>
                    <div className={`${classes.dotter} ${classes.topspc}`} >
                        <div className={classes.dott} />
                        <div className={classes.dotters} >
                            <div>
                                <p className={classes.akant}>Zenith Bank Savings</p>
                                <p className={classes.akantnum}>****4455</p>
                            </div>
                            <div>
                                <p className={classes.amount}>₦0.00</p>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* table 1 ends here */}
            {/* table 2 begins here */}

            <div className={classes.graphContainKnt}>
                {/* Header */}
                <div className={classes.flex}>
                    <div>
                        <h2 className={classes.rvntxt}>Outstanding Invoices</h2>
                        <p className={classes.rvntxtsml}>Pending payments</p>
                    </div>
                    <div className={classes.divplus} onClick={() => navigate('/transactions/receivables/sales')}>
                        <img src={plus} className={classes.plusicon}/>
                        <p className={classes.viwal}>Sales Invoice</p>
                    </div>
                </div>

                {/* Transaction  */}
                <div className={classes.trstnal}>
                    <div className={classes.dotter} >
                        <div className={classes.dot} />
                        <div className={classes.dotters} >
                            <div>
                                <p className={classes.akant}>Aliko Enterprises</p>
                                <p className={classes.akantnum}>INV-001 • Due: 2024-01-20</p>
                            </div>
                            <div>
                                <p className={classes.amount}>₦0.00</p>
                                <button className={classes.cnnectd}>overdue</button>
                            </div>

                        </div>
                    </div>
                    <div className={`${classes.dotter} ${classes.topspc}`}>
                        <div className={classes.dott} />
                        <div className={classes.dotters} >
                            <div>
                                <p className={classes.akant}>Lagos Trading Co.</p>
                                <p className={classes.akantnum}>INV-002 • Due: 2024-01-25</p>
                            </div>
                            <div>
                                <p className={classes.amount}>₦0.00</p>
                                <button className={classes.cnnected}>pending</button>
                            </div>

                        </div>
                    </div>
                    <div className={`${classes.dotter} ${classes.topspc}`} >
                        <div className={classes.dott} />
                        <div className={classes.dotters} >
                            <div>
                                <p className={classes.akant}>Kano Trading Co.</p>
                                <p className={classes.akantnum}>INV-002 • Due: 2024-01-25</p>
                            </div>
                            <div>
                                <p className={classes.amount}>₦0.00</p>
                                <button className={classes.cnnected}>pending</button>
                            </div>

                        </div>
                    </div>
                </div>
            </div>

            {/* table 2 ends here */}
        </div>
    );
}